import React, { useEffect, useState } from "react";
import {
  FiMapPin,
  FiPhone,
  FiMail,
  FiClock,
  FiSend,
  FiPhoneCall ,
  FiCalendar,
 FiShield, FiStar ,
 FiUsers
} from "react-icons/fi";
const ContactSection = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  


const inputStyle = {
  flex: "1 1 45%",
  padding: "12px 16px",
  borderRadius: "8px",
  border: "1px solid #e5e7eb",
  fontSize: "0.9rem",
  color: "#111827",
};
const stats = [
    { icon: <FiUsers size={24} color="#047857" />, value: "500+", label: "Happy Clients" },
    { icon: <FiClock size={24} color="#047857" />, value: "24hrs", label: "Response Time" },
    { icon: <FiShield size={24} color="#047857" />, value: "99.9%", label: "Security Rate" },
    { icon: <FiStar size={24} color="#047857" />, value: "4.9/5", label: "Client Rating" },
  ];

  const testimonials = [
    {
      text: "Transaction Analysts helped us implement a robust payment gateway. Their expertise in digital payments is unmatched.",
      name: "Rajesh Kumar",
      company: "FinTech Solutions",
    },
    {
      text: "Quick response time and excellent support. They solved our POS integration issues within 24 hours.",
      name: "Priya Sharma",
      company: "E-Commerce Plus",
    },
    {
      text: "Professional team with deep knowledge of payment systems. Highly recommend their advisory services.",
      name: "Amit Patel",
      company: "RetailTech",
    },
  ];
const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "How quickly do you respond to support requests?",
      answer:
        "We typically respond within 24 hours during business days. For urgent issues, we offer priority support with faster response times.",
    },
    {
      question: "Do you provide on-site consultation?",
      answer:
        "Yes, we offer on-site consultation for complex implementations and can visit your office in Bangalore and surrounding areas.",
    },
    {
      question: "What payment systems do you specialize in?",
      answer:
        "We specialize in Digital Wallets, Aadhaar-based services, POS systems, ATM/POS monitoring, and comprehensive payment advisory services.",
    },
  ];

  const styles = {
    faqContainer: {
      fontFamily: 'Arial, sans-serif',
      backgroundColor: '#f9fafb',
      padding: '30px',
      borderRadius: '8px',
      width: '100%',
      maxWidth: '1000px',
      margin: '0 auto',
 
    },
    heading: {
      fontSize: '32px',
      color: '#2a2b2e',
      marginBottom: '10px',
      fontWeight:'bold',
     
    },
    subheading: {
      fontSize: '16px',
      color: '#676767',
      marginBottom: '20px',
    },
    faqList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
    },
    faqItem: {
    //   backgroundColor: 'white',
      borderRadius: '8px',
      padding: '15px',
      boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    },
    faqQuestion: {
      cursor: 'pointer',
    },
    faqQuestionText: {
      fontSize: '15px',
      fontWeight: 'bold',
      color: '#333',
    },
    faqAnswer: {
      marginTop: '10px',
      fontSize: '16px',
      color: '#555',
    },
  };


  return (
    <>
      <div
      className="contact-container"
      style={{
        background: "linear-gradient(135deg, #fcf8e5ff, #ecfdf5)",
        paddingBottom: "70px",
        paddingTop: "60px",
      }}
    >
      <section
        className="container"
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "space-between",
          alignItems: "center",
          fontFamily: "'Inter', sans-serif",
          gap: "40px",
          padding: isMobile ? "0 20px" : "",
        }}
      >
        {/* Left Text Section */}
        <div
          style={{
            flex: "1 1 45%",
            minWidth: "300px",
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <h2
            style={{
              fontSize: isMobile ? "2rem" : "40px",
              fontWeight: "700",
              color: "#111827",
              lineHeight: "1.3",
            }}
          >
            Let's Connect. <br />
            <span style={{ color: "#1f8c50" }}>We're Here to Help.</span>
          </h2>

          <p
            style={{
              fontSize: "18px",
              color: "#4b5563",
              margin: "20px 0",
            }}
          >
            Fast support, friendly experts, and clear solutions for all your payment system needs.
          </p>

          <ul
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: isMobile ? "16px" : "30px",
              listStyle: "none",
              padding: 0,
              fontSize: "16px",
              color: "#374151",
              marginTop: "30px",
              justifyContent: isMobile ? "center" : "flex-start",
              alignItems: isMobile ? "center" : "flex-start",
            }}
          >
            {["Quick Response", "Expert Support", "Clear Solutions"].map((text, idx) => (
              <li key={idx} style={{ display: "flex", alignItems: "center" }}>
                <span
                  style={{
                    display: "inline-block",
                    width: 10,
                    height: 10,
                    backgroundColor: "#1f8c50",
                    borderRadius: "50%",
                    marginRight: "8px",
                  }}
                ></span>
                {text}
              </li>
            ))}
          </ul>
        </div>

        {/* Right Image Section */}
        <div
          style={{
            flex: "1 1 45%",
            minWidth: "300px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: isMobile ? "30px" : "0",
          }}
        >
          <img
            src="/assets/images/contactimg.png"
            alt="Support Illustration"
            style={{
              width: "100%",
              maxWidth: isMobile ? "320px" : "500px",
              borderRadius: "16px",
            }}
          />
        </div>
      </section>
    </div>


     <section className="container"
      style={{
        maxWidth: "1300px",
        margin: "0 auto",
        padding: "40px 0px",
        padding:"10px",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "40px",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        {/* Left Column */}
        <div style={{ flex: "1 1 400px", maxWidth: "500px" }}>
          <h2 style={{ fontSize: "28px", fontWeight: 600, marginBottom: "12px", color: "#111827" }}>
            Get in Touch
          </h2>
          <p style={{ fontSize: "17px", color: "#6b7280", marginBottom: "30px" }}>
            Whether it's Digital Wallets, Aadhaar services, POS monitoring, or advisory —
            our payment experts are just a call or message away.
          </p>

          {/* Info Items */}
          {[
            {
              icon: <FiMapPin size={20} color="#059669" />,
              label: "Office Address",
              content: (
                <>
                  Transaction Analysts India Pvt Ltd<br />
                 #4, Satyam Arcade, 1st floor, 1st Phase

 BTM Layout 2nd Stage,

Bengaluru, Karnataka - 560076, India
                </>
              ),
            },
            {
              icon: <FiPhone size={20} color="#059669" />,
              label: "Phone Numbers",
              content: (
                <>
                  Landline: +91-80-26784479<br />
                  Mobile: +91-9167683845
                </>
              ),
            },
            {
              icon: <FiMail size={20} color="#059669" />,
              label: "Email Us",
              content: <>support@taipl.in</>,
            },
            {
              icon: <FiClock size={20} color="#059669" />,
              label: "Business Hours",
              content: (
                <>
                 <p>
  <strong>Monday – Friday:</strong> 9:00 AM – 6:30 PM<br />
  <strong>Saturday:</strong> 9:00 AM – 6:30 PM (Closed on 2nd & 4th Saturdays)<br />
  <strong>Sunday:</strong> Closed
</p>

                </>
              ),
            },
            {
  icon: <FiUsers size={20} color="#059669" />,
  label: "Nodal Officers",
  content: (
    <>
      <p style={{ marginBottom: "10px" }}>
        <strong>Officer 1:</strong><br />
        Mr. Kiran Kumar<br />
        Mobile: +91-8919056119<br />
        Email: <a href="mailto:kirankumar.p@taipl.in">kirankumar.p@taipl.in</a>
      </p>
      <p>
        <strong>Officer 2:</strong><br />
        Mr. Siddhartha Desu<br />
        Mobile: +91-9390358339<br />
        Email: <a href="mailto:siddhartha.d@transactionanalysts.com">siddhartha.d@transactionanalysts.com</a>
      </p>
    </>
  ),
},

          ].map(({ icon, label, content }, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
                marginBottom: "24px",
              }}
            >
              <div style={{ background: "#ecfdf5", padding: 12, borderRadius: 12 }}>{icon}</div>
              <div>
                <h4 style={{ fontSize: "18px", fontWeight: 600, marginBottom: "4px" }}>{label}</h4>
                <p style={{ fontSize: "17px", color: "#4b5563", margin: 0 }}>{content}</p>
              </div>
            </div>
          ))}

        </div>

        {/* Right Column */}
        <div style={{ flex: "1 1 400px", maxWidth: "500px" }}>
          <h2 style={{ fontSize: "28px", fontWeight: 600, marginBottom: "12px", color: "#111827" }}>
            Send us a Message
          </h2>
          <p style={{ fontSize: "18px", color: "#6b7280", marginBottom: "20px" }}>
            Fill out the form below and we'll respond within 24 hours.
          </p>

          <form>
            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
              <input type="text" placeholder="Your Name *" required style={inputStyle} />
              <input type="email" placeholder="Email Address *" required style={inputStyle} />
            </div>
            <input
              type="tel"
              placeholder="Phone Number *"
              required
              style={{ ...inputStyle, width: "100%", marginTop: 12 }}
            />
            <textarea
              placeholder="Your Message *"
              required
              rows={4}
              style={{
                ...inputStyle,
                width: "100%",
                resize: "none",
                marginTop: 12,
              }}
            />
            <button
              type="submit"
              style={{
                marginTop: "24px",
                width: "100%",
                backgroundColor: "#15803d",
                color: "#fff",
                padding: "12px",
                fontSize: "0.95rem",
                borderRadius: "8px",
                border: "none",
                fontWeight: 600,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <FiSend /> Send Message
            </button>
            <p style={{ fontSize: "0.8rem", color: "#6b7280", marginTop: "16px" }}>
              By submitting this form, you agree to our privacy policy and terms of service.
            </p>
          </form>
          
          {/* Quick Actions */}
          <div style={{ marginTop: "40px" }}>
            <h3 style={{ fontSize: "1rem", fontWeight: 600, marginBottom: "16px" }}>Quick Actions</h3>
            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginBottom: "16px" }}>
              <div
                style={{
                  flex: "1 1 200px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  background: "#f0fdf4",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  color: "#047857",
                  fontWeight: 500,
                }}
              >
                <FiPhoneCall /> Call Now
              </div>
              <div
                style={{
                  flex: "1 1 200px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  background: "#f0fdf4",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  color: "#047857",
                  fontWeight: 500,
                }}
              >
                <FiMail /> Email Us
              </div>
            </div>
            <div
              style={{
                background: "#ecfdf5",
                padding: "12px 16px",
                borderRadius: "8px",
                color: "#047857",
                border:"1px solid gray",
                fontSize: "0.95rem",
                fontWeight: 500,
              }}
            >
              ● Typical response time: 24 hours
            </div>
          </div>
         
        </div>
      </div>
    </section>



<section
      style={{
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "60px 20px",
        fontFamily: "'Inter', sans-serif",
        textAlign: "center",
      }}
    >
      {/* Heading */}
      <h2
        style={{
          fontSize: "40px",
          fontWeight: "700",
          color: "#111827",
          marginBottom: "10px",
        }}
      >
        Visit Our Office
      </h2>
      <p
        style={{
          fontSize: "18px",
          color: "#6b7280",
          maxWidth: "600px",
          margin: "0 auto 40px auto",
        }}
      >
        Located in the heart of Bangalore's BTM Layout, we're easily accessible and ready to
        meet you in person.
      </p>

      {/* Google Map */}
      <div
        style={{
          width: "100%",
          height: "400px",
          overflow: "hidden",
          borderRadius: "12px",
          marginBottom: "50px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.05)",
        }}>
    {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.865839082309!2d77.60808207484041!3d12.916343187393922!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae14fc32b4f8c9%3A0x9ba0dd95cd719e5f!2sTransaction%20Analysts%20India%20Pvt.%20Ltd!5e0!3m2!1sen!2sin!4v1752228352991!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
        <iframe
          title="Office Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.865839082309!2d77.60808207484041!3d12.916343187393922!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae14fc32b4f8c9%3A0x9ba0dd95cd719e5f!2sTransaction%20Analysts%20India%20Pvt.%20Ltd!5e0!3m2!1sen!2sin!4v1752228352991!5m2!1sen!2sin"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>

      {/* Info Cards */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "30px",
          justifyContent: "center",
        }}
      >
        {/* Card 1 */}
        <div
          style={{
            flex: "1 1 250px",
            minWidth: "240px",
            // backgroundColor: "#f0fdf4",
            borderRadius: "12px",
            padding: "20px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#d1fae5",
              padding: "12px",
              borderRadius: "12px",
              display: "inline-block",
              marginBottom: "12px",
            }}
          >
            <FiCalendar size={24} color="#047857" />
          </div>
          <h4 style={{ fontSize: "18px", fontWeight: 600, color: "#111827", marginBottom: "6px" }}>
            Schedule a Visit
          </h4>
          <p style={{ fontSize: "16px", color: "#6b7280" }}>
            Call ahead to ensure we're available for an in-person consultation.
          </p>
        </div>

        {/* Card 2 */}
        <div
          style={{
            flex: "1 1 250px",
            minWidth: "240px",
            // backgroundColor: "#f0fdf4",
            borderRadius: "12px",
            padding: "20px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#d1fae5",
              padding: "12px",
              borderRadius: "12px",
              display: "inline-block",
              marginBottom: "12px",
            }}
          >
            <FiMapPin size={24} color="#047857" />
          </div>
          <h4 style={{ fontSize: "18px", fontWeight: 600, color: "#111827", marginBottom: "6px" }}>
            Easy Access
          </h4>
          <p style={{ fontSize: "16px", color: "#6b7280" }}>
            Conveniently located in BTM Layout with parking facilities available.
          </p>
        </div>

        {/* Card 3 */}
        <div
          style={{
            flex: "1 1 250px",
            minWidth: "240px",
            // backgroundColor: "#f0fdf4",
            borderRadius: "12px",
            padding: "20px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#d1fae5",
              padding: "12px",
              borderRadius: "12px",
              display: "inline-block",
              marginBottom: "12px",
            }}
          >
            <FiClock size={24} color="#047857" />
          </div>
          <h4 style={{ fontSize: "18px", fontWeight: 600, color: "#111827", marginBottom: "6px" }}>
            Office Hours
          </h4>
          <p style={{ fontSize: "16px", color: "#6b7280" }}>
            Mon–Fri: 9 AM - 6 PM <br /> Sat: 9 AM - 1 PM
          </p>
        </div>
      </div>
    </section>

  <section
      style={{
        backgroundColor: "#f9fdfa",
        padding: "60px 20px",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      {/* Section 1: Stats */}
      <div style={{ textAlign: "center", marginBottom: "50px" }}>
        <h2 style={{ fontSize: "40px", fontWeight: "700", color: "#111827", marginBottom: "8px" }}>
          Trusted by Industry Leaders
        </h2>
        <p style={{ color: "#6b7280", fontSize: "1rem" }}>
          Our track record speaks for itself
        </p>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "24px",
            marginTop: "40px",
          }}
        >
          {stats.map((item, i) => (
            <div
              key={i}
              style={{
                flex: "1 1 180px",
                maxWidth: "220px",
                backgroundColor: "#fff",
                padding: "24px",
                borderRadius: "12px",
                textAlign: "center",
                boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
              }}
            >
              <div
                style={{
                  backgroundColor: "#ecfdf5",
                  padding: "12px",
                  borderRadius: "10px",
                  display: "inline-block",
                  marginBottom: "10px",
                }}
              >
                {item.icon}
              </div>
              <h3 style={{ fontSize: "25px", fontWeight: 700, color: "#111827" }}>
                {item.value}
              </h3>
              <p style={{ fontSize: "18px", color: "#6b7280" }}>{item.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Section 2: Testimonials */}
      <div style={{ textAlign: "center" }}>
        <h2 style={{ fontSize: "2rem", fontWeight: "700", color: "#111827", marginBottom: "8px" }}>
          What Our Clients Say
        </h2>
        <p style={{ color: "#6b7280", fontSize: "1rem", marginBottom: "40px" }}>
          Real feedback from real businesses
        </p>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "24px",
          }}
        >
          {testimonials.map((t, i) => (
            <div
              key={i}
              style={{
                flex: "1 1 280px",
                backgroundColor: "#fff",
                padding: "24px",
                borderRadius: "12px",
                maxWidth: "350px",
                textAlign: "left",
                boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
              }}
            >
              {/* Stars */}
              <div style={{ color: "#fbbf24", fontSize: "1.3rem", marginBottom: "12px" }}>
  {"\u2605\u2605\u2605\u2605\u2605"}
</div>


              {/* Quote */}
              <p
                style={{
                  fontStyle: "italic",
                  color: "#374151",
                  fontSize: "0.95rem",
                  marginBottom: "20px",
                }}
              >
                “{t.text}”
              </p>

              {/* Name & Company */}
              <p
                style={{
                  fontWeight: 600,
                  color: "#111827",
                  fontSize: "0.95rem",
                  marginBottom: "4px",
                }}
              >
                {t.name}
              </p>
              <p style={{ color: "#6b7280", fontSize: "0.85rem" }}>{t.company}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

<section>

     <div style={styles.faqContainer}>
      <h2 style={styles.heading}>Frequently Asked Questions</h2>
      <p style={styles.subheading}>Get quick answers to common questions</p>
      <div style={styles.faqList}>
        {faqs.map((faq, index) => (
          <div key={index} style={styles.faqItem}>
            <div
              style={styles.faqQuestion}
              onClick={() => toggleFAQ(index)}
            >
              <h3 style={styles.faqQuestionText}>{faq.question}</h3>
            </div>
            {activeIndex === index && (
              <div style={styles.faqAnswer}>
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
</section>

<section>

     <div style={{ backgroundColor: '#0e9d58', padding: '60px 20px', textAlign: 'center', color: '#fff' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <div style={{ marginBottom: '40px' }}>
   <button style={{
  backgroundColor: '#0e9d58',
  color: 'white',
  fontWeight:'revert-layer',
  padding: '12px 30px',  // Adjusted padding to match the button size
  fontSize: '16px',       // Slightly larger font for better clarity
  border: 'none',
  borderRadius: '50px',   // Increased border-radius for a rounded appearance
  cursor: 'pointer',
  marginBottom: '20px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Added subtle shadow for a raised effect
  transition: 'all 0.3s ease',   // Smooth transition on hover
}} 
// onMouseEnter={(e) => e.target.style.backgroundColor = '#0e9d58'}  
// onMouseLeave={(e) => e.target.style.backgroundColor = '#fff'}      
>
  Ready to Transform Your Business?
</button>

          <h1 style={{ fontSize: '36px', fontWeight: 'bold', marginBottom: '20px' }}>
            Let's Accelerate Your Digital Transformation
          </h1>
          <p style={{ fontSize: '18px', marginBottom: '30px' }}>
            From digital wallets to comprehensive payment solutions, we help businesses simplify, secure, and scale their payment systems.
          </p>
   
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '40px' }}>
          <p style={{ display: 'flex', alignItems: 'center', fontSize: '14px', color: '#fff' }}>
            <span style={{
              width: '8px',
              height: '8px',
              backgroundColor: '#fff',
              borderRadius: '50%',
              marginRight: '10px'
            }}></span>
            No Setup Fees
          </p>
          <p style={{ display: 'flex', alignItems: 'center', fontSize: '14px', color: '#fff' }}>
            <span style={{
              width: '8px',
              height: '8px',
              backgroundColor: '#fff',
              borderRadius: '50%',
              marginRight: '10px'
            }}></span>
            24/7 Support
          </p>
          <p style={{ display: 'flex', alignItems: 'center', fontSize: '14px', color: '#fff' }}>
            <span style={{
              width: '8px',
              height: '8px',
              backgroundColor: '#fff',
              borderRadius: '50%',
              marginRight: '10px'
            }}></span>
            Industry Certified
          </p>
        </div>
      </div>
    </div>
</section>

    </>
  );
};

export default ContactSection;
